import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  Alert,
} from '@mui/material';
import { useTenantStore } from '../../../stores/tenant.store';
import { useAcademic } from '../../../hooks/use-academic';

interface CreateCourseDialogProps {
  open: boolean;
  onClose: () => void;
}

export function CreateCourseDialog({ open, onClose }: CreateCourseDialogProps) {
  const { currentTenantId } = useTenantStore();
  const { createCourse, isCreatingCourse } = useAcademic();

  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [credits, setCredits] = useState<number | ''>('');
  const [error, setError] = useState<string | null>(null);

  const handleClose = () => {
    setName('');
    setCode('');
    setCredits('');
    setError(null);
    onClose();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!currentTenantId) return;

    setError(null);
    try {
      await createCourse({
        tenantId: currentTenantId,
        name,
        code,
        credits: Number(credits) || 0,
      });
      handleClose();
    } catch (err: any) {
      setError(err.message || 'Error al crear el curso');
    }
  };

  const isFormValid = !!name && !!code && !!credits;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Crear Curso</DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 1 }}>
            {error && <Alert severity="error">{error}</Alert>}

            <TextField
              label="Nombre del Curso"
              required
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
              helperText="Ej. Teología Sistemática I"
            />

            <TextField
              label="Código"
              required
              fullWidth
              value={code}
              onChange={(e) => setCode(e.target.value)}
              helperText="Ej. TEO101"
            />

            <TextField
              label="Créditos"
              type="number"
              required
              fullWidth
              value={credits}
              onChange={(e) => setCredits(e.target.value ? Number(e.target.value) : '')}
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleClose} disabled={isCreatingCourse}>
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={isCreatingCourse || !isFormValid}
            sx={{ minWidth: 120 }}
          >
            {isCreatingCourse ? 'Creando...' : 'Crear'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
